const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const RestaurantAnalyseForm = require('app/restaurant/analyse/Form');
const RestaurantAnalyseInvoiceBox = require('app/restaurant/analyse/InvoiceBox');

class AnalyseTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onAnalyseReady = this.onAnalyseReady.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.loadData();
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildAnalyseQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTab(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildAnalyseQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'orderBy': 'id',
            'dir': 'DESC',
            'first': 1,
            'filter':{
                'restaurant': id,
            }
        };

        let fields = [
            'id',
            'analysePeriodBegin',
            'analysePeriodEnd'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProspectAnalyses',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,
        });

        return query;
    }


    buildTab(data){

        this.analyses = data.restaurantProspectAnalyses.edges;

        this.$content = $('<div/>');

        this.$container
        .html('')
        .append(this.buildForm())
        .append(this.$content);

        this.form.onDOMReady();
    }

    buildForm(){
        this.form = new RestaurantAnalyseForm({
            'restaurant': this.restaurant,
            'analyses': this.analyses,
            'success': this.onAnalyseReady,
        });
        return this.form.getForm();
    }

    onAnalyseReady(data){
        this.analyse = data.analyse;

        this.$content
        .html('')
        .append(this.buildInvoiceBox());
    }


    buildInvoiceBox(){
        this.$invoiceBoxContainer = $('<div/>');

        this.InvoiceBox = new RestaurantAnalyseInvoiceBox({
            '$container': this.$invoiceBoxContainer,
            'restaurant': this.restaurant,
            'analyse': this.analyse,
        });

        return this.$invoiceBoxContainer;
    }

}

module.exports = AnalyseTab;

